import { useTheme } from "@emotion/react";
import { Box, Slider } from "@mui/material";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

const marks = [
  {
    value: 0,
    label: "0%",
  },
  {
    value: 25,
    label: "25%",
  },
  {
    value: 50,
    label: "50%",
  },
  {
    value: 75,
    label: "75%",
  },
  {
    value: 100,
    label: "100%",
  },
];

function RangeBuildCode({
  setDataPercentFriends,
  setGaugePercent,
  gaugePercent,
}) {
  const theme = useTheme()

  const percentClick = (_, val) => {
    setGaugePercent(val);
    highnessPercentFriends(val);
  };

  const highnessPercentFriends = (val) => {
    const percentFriends = 100 - val;
    setDataPercentFriends(percentFriends);
  };

  return (
    <Box px={6} py={1} mb={1}>
      <Slider
        color={actionButtonBg(theme)}
        aria-label="Custom marks"
        defaultValue={0}
        value={gaugePercent}
        onChange={(e, value) => {
          percentClick(e, value);
        }}
        onClick={() => { }}
        getAriaValueText={(value) => {
          return value + " %";
        }}
        step={5}
        valueLabelDisplay="auto"
        marks={marks}
      />
    </Box>
  );
}

export default RangeBuildCode;
